import {
  AccountMetadata,
  FPEnvironmentLocker,
} from "../../reducers/environments";

import { loadFreshpaintSnippetOnce } from "../../App.jsx";

export default class OptInEventEmitter {
  private readonly accountMetadata: AccountMetadata;
  private readonly envLocker: FPEnvironmentLocker;

  constructor(
    accountMetadata: AccountMetadata,
    envLocker: FPEnvironmentLocker
  ) {
    this.accountMetadata = accountMetadata;
    this.envLocker = envLocker;
  }

  public async trackBannerViewed(): Promise<void> {
    return new Promise((resolve) => {
      loadFreshpaintSnippetOnce(this.accountMetadata, () => {
        window.freshpaint.track(
          "fp_events_library__sunset_banner_viewed",
          {
            envID: this.envLocker.getEnvID(),
          },
          undefined,
          resolve
        );
      });
    });
  }

  public async trackBannerDismissed(): Promise<void> {
    return new Promise((resolve) => {
      loadFreshpaintSnippetOnce(this.accountMetadata, () => {
        window.freshpaint.track(
          "fp_events_library__sunset_banner_dismissed",
          {
            envID: this.envLocker.getEnvID(),
          },
          undefined,
          resolve
        );
      });
    });
  }

  public async trackOptInNowClicked(): Promise<void> {
    return new Promise((resolve) => {
      loadFreshpaintSnippetOnce(this.accountMetadata, () => {
        window.freshpaint.track(
          "fp_events_library__sunset_opt_in_now_clicked",
          {
            envID: this.envLocker.getEnvID(),
          },
          undefined,
          resolve
        );
      });
    });
  }
}
